import cn from 'classnames';

import { BALANCE_MODAL_TYPE } from 'constants/common';

import './styles.scss';
const BalanceModal = ({
  showModal = false,
  type = BALANCE_MODAL_TYPE.BALANCE_SDK,
}) => {
  return (
    <div id={type} className={cn(`${showModal ? 'd-block' : 'd-none'}`)}></div>
  );
};

export default BalanceModal;
